import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'A los 56 años creía que era tarde. Hoy hago reportes en Excel y tengo 2 clientes pagando.',
    author: 'Diana M.',
    location: 'Córdoba'
  }, {
    text: 'El Manual Pro me enseñó a cobrar con confianza. Antes hacía trabajo gratis por miedo.',
    author: 'Sofía C.',
    location: 'La Plata'
  }, {
    text: 'Las 50 plantillas de mail las uso todos los días. Mis clientes dicen que soy muy profesional.',
    author: 'Valentina L.',
    location: 'Rosario'
  }, {
    text: 'El Bono 6 de confianza digital me hizo entender que el problema no era la edad — era el sistema.',
    author: 'Patricia A.',
    location: 'Neuquén'
  }];
  return <section className="bg-nightDeep py-12 text-white" data-id="element-261">
      <div className="max-w-6xl mx-auto px-6" data-id="element-262">
        <div className="text-center mb-8" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-264">
            ❤️ LO QUE DICEN LAS QUE YA EMPEZARON
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-265">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="glass p-8 rounded-2xl flex flex-col" data-id="element-266">
              <div className="flex gap-1 mb-4" data-id="element-267">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-gold-accent fill-current" data-id="element-268" />)}
              </div>
              <p className="text-lg italic mb-6 flex-1 text-white" data-id="element-269">
                "{testimonial.text}"
              </p>
              <div className="border-t border-white/10 pt-4" data-id="element-270">
                <p className="font-bold text-gold-accent" data-id="element-271">
                  {testimonial.author}
                </p>
                <p className="text-sm text-textLight" data-id="element-272">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}